<template>
	<div data-tour-scope="users">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title>Utenti</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>

							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!-- una sola azione possibile: il piu' porta dritto alla pagina, senza menu -->
								<v-btn text title="Nuovo utente" data-tour="add" @click="openNew">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
							</v-toolbar-items>
						</v-toolbar>


						<!-- filtri in pagina: finiscono nell'URL, un refresh o il ritorno dalla scheda li ritrova -->
						<v-col cols="12">
							<v-row data-tour="search">
								<v-col cols="12" :md="profiliDisponibili.length > 1 ? 6 : 12">
									<v-text-field v-model="searchfield" label="Cerca utente, email o profilo" outlined dense append-icon="mdi-magnify" clearable hide-details />
								</v-col>
								<!-- solo se ci sono utenti di piu' profili (superadmin) -->
								<v-col v-if="profiliDisponibili.length > 1" cols="12" md="6">
									<v-autocomplete v-model="settings.filters.profile" :items="profiliDisponibili" label="Profilo" prepend-inner-icon="mdi-domain" outlined dense clearable hide-details />
								</v-col>
							</v-row>
						</v-col>

						<!-- la tabella nasce a utenti caricati: vuota, riporterebbe a pagina 1 quella letta dall'URL -->
						<v-data-table
							v-if="loaded"
							:headers="headers"
							:items="utenti"
							:search="settings.search"
							:options.sync="settings.options"
							must-sort
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="_id"
							class="elevation-0"
							data-tour="table"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni utente diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="user-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="[item.name || item.email || 'Utente', item.profileName].filter(Boolean).join(' · ')" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small color="primary" v-bind="attrs" v-on="on" data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link data-tour="row-edit" @click="editItem(item)">
																<v-list-item-title class="size9">Modifica</v-list-item-title>
															</v-list-item>
															<v-list-item v-if="getRole === 0" link @click="executeLoginAs(item)">
																<v-list-item-title class="size9">Loggati come</v-list-item-title>
															</v-list-item>
															<v-list-item v-if="getRole === 0 && item.twoFactor && item.twoFactor.enabled" link @click="openTwoFactorReset(item)">
																<v-list-item-title class="size9">Reimposta verifica in due passaggi</v-list-item-title>
															</v-list-item>
															<v-list-item link @click="createMyBadge(item)">
																<v-list-item-title class="size9">Stampa badge</v-list-item-title>
															</v-list-item>
															<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
																<v-list-item-title class="size9">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<template v-if="getRole === 0">
													<div class="d-flex align-center justify-space-between">
														<span class="card-label">Attivo</span>
														<v-switch
															data-tour="active"
															:input-value="item.active"
															color="primary"
															dense
															hide-details
															class="mt-0 pt-0"
															@change="openActiveConfirm(item, $event)"
														></v-switch>
													</div>
													<div class="d-flex align-center justify-space-between mt-1">
														<span class="card-label">Scaduto</span>
														<v-switch
															data-tour="expired"
															:input-value="item.expired"
															color="primary"
															dense
															hide-details
															class="mt-0 pt-0"
															@change="openExpiredConfirm(item, $event)"
														></v-switch>
													</div>
												</template>
											</key-value-card>
										</td>
									</tr>
									<tr v-if="!items.length">
										<td :colspan="headers.length" class="text-center grey--text py-6">Nessun utente</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="item in items" :key="item._id">
										<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
														<v-icon dark> mdi-dots-vertical </v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item link data-tour="row-edit" @click="editItem(item)">
														<v-list-item-title class="size9">Modifica</v-list-item-title>
													</v-list-item>
													<v-list-item v-if="getRole === 0" link @click="executeLoginAs(item)">
														<v-list-item-title class="size9">Loggati come</v-list-item-title>
													</v-list-item>
													<v-list-item v-if="getRole === 0 && item.twoFactor && item.twoFactor.enabled" link @click="openTwoFactorReset(item)">
														<v-list-item-title class="size9">Reimposta verifica in due passaggi</v-list-item-title>
													</v-list-item>
													<v-list-item link @click="createMyBadge(item)">
														<v-list-item-title class="size9">Stampa badge</v-list-item-title>
													</v-list-item>
													<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
														<v-list-item-title class="size9">Elimina</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>
										<td class="text-left">
											<div class="font-weight-medium">{{ item.profileName || 'Profilo senza nome' }}</div>
											<div class="text-caption grey--text">{{ item.profile }}</div>
										</td>
										<td class="text-left">{{ item.name }}</td>
										<td class="text-left">{{ item.email }}</td>
										<td>
											<v-switch
												data-tour="active"
												v-if="getRole === 0"
												:input-value="item.active"
												color="primary"
												dense
												hide-details
												@change="openActiveConfirm(item, $event)"
											></v-switch>
										</td>
										<td>
											<v-switch
												data-tour="expired"
												v-if="getRole === 0"
												:input-value="item.expired"
												color="primary"
												dense
												hide-details
												@change="openExpiredConfirm(item, $event)"
											></v-switch>
										</td>
									</tr>
									<tr v-if="!items.length">
										<td :colspan="headers.length" class="text-center grey--text py-6">Nessun utente</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog v-model="dialogconfirm" max-width="400">
			<v-card>
				<v-card-title class="headline">Eliminare l'utente?</v-card-title>
				<v-card-text class="text-left">
					{{ form && (form.name || form.email) }} ({{ form && form.email }}) perderà l'accesso al gestionale per sempre: l'utente non potrà più essere ripristinato.
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn text color="primary" @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn text color="primary" @click="confirmDelete"> Elimina </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogTwoFactorReset" max-width="400">
			<v-card>
				<v-card-title class="headline">Reimpostare la verifica in due passaggi?</v-card-title>
				<v-card-text class="text-left">
					La verifica in due passaggi di {{ pendingTwoFactorItem && pendingTwoFactorItem.email }} verrà disattivata e le sue sessioni aperte chiuse.
					Usalo solo se l'utente ha perso il telefono o l'accesso all'email: potrà riattivarla dal suo Profilo.
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="dialogTwoFactorReset = false"> Annulla </v-btn>
					<v-btn color="primary" @click="confirmTwoFactorReset"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogConfirmActive" max-width="400">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text class="text-left">
					Vuoi {{ pendingActiveValue ? 'attivare' : 'disattivare' }} l'utente {{ pendingActiveItem && pendingActiveItem.email }}?
					<template v-if="!pendingActiveValue"><br />Non potrà più accedere alla piattaforma.</template>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn text color="primary" @click="cancelActiveToggle"> Annulla </v-btn>

					<v-btn text color="primary" @click="confirmActiveToggle"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogConfirmExpired" max-width="400">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text class="text-left">
					Vuoi {{ pendingExpiredValue ? 'attivare' : 'disattivare' }} la modalità expired per il profilo
					{{ pendingExpiredItem && (pendingExpiredItem.profileName || pendingExpiredItem.profile) }}? Riguarda tutti gli utenti di quel profilo.
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn text color="primary" @click="cancelExpiredToggle"> Annulla </v-btn>

					<v-btn text color="primary" @click="confirmExpiredToggle"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import axios from 'axios';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { useTour } from '@/components/core/tour/useTour';
import { listRouteState } from '@/components/core/list/listRouteState';
import { createUsersTourSteps } from './users-tour';
import { mapGetters, mapMutations, mapActions } from 'vuex';

const LIST_SIZE = [10, 25, 50, 100];

export default {
	name: 'Users',
	/*
	 * Pagina, righe, ordinamento, ricerca e profilo stanno nell'URL. La lista arriva intera
	 * dal server e si filtra qui: al cambio di stato non c'e' niente da ricaricare.
	 */
	mixins: [listRouteState({ filters: { profile: 'string' }, perPageOptions: LIST_SIZE, fetch: 'listChanged' })],
	setup() {
		return { tour: useTour(createUsersTourSteps()) };
	},
	data() {
		return {
			loaded: false,
			searchfield: '',
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {
					// id del profilo scelto nel filtro (vuoto = tutti)
					profile: '',
				},
				options: {
					sortBy: ['profileName'],
					sortDesc: [false],
					page: 1,
					itemsPerPage: 10,
				},
			}),
			listSize: LIST_SIZE,

			headers: [
				// colonna del menu a tre puntini: non si ordina
				{ text: '', value: 'menu', sortable: false, filterable: false },
				// ricerca e ordinamento sul nome del profilo, non sull'id
				{ text: 'Profilo', value: 'profileName' },
				{ text: 'Nome', value: 'name' },
				{ text: 'Email', value: 'email' },
				{ text: 'Attivo', value: 'active', sortable: false, filterable: false },
				{ text: 'Scaduto', value: 'expired', sortable: false, filterable: false },
			],

			form: null,
			dialogconfirm: false,
			dialogConfirmExpired: false,
			pendingExpiredItem: null,
			pendingExpiredValue: false,
			dialogConfirmActive: false,
			pendingActiveItem: null,
			pendingActiveValue: false,
			dialogTwoFactorReset: false,
			pendingTwoFactorItem: null,
		};
	},
	watch: {
		// ricerca dal vivo sulla lista gia' caricata: il mixin la porta nell'URL
		searchfield(value) {
			this.settings.search = value || '';
		},
	},
	created() {
		this.initialize();
	},
	components: {
		KeyValueCard,
		TourOverlay,
	},
	computed: {
		// profili presenti nella lista, per il filtro (nome + numero di utenti)
		profiliDisponibili() {
			const conteggio = {};
			(this.getUsers || []).forEach(u => {
				const id = String(u.profile || '');
				if (!id) return;
				conteggio[id] = conteggio[id] || { value: id, nome: u.profileName || 'Profilo senza nome', n: 0 };
				conteggio[id].n += 1;
			});
			return Object.values(conteggio)
				.sort((a, b) => a.nome.localeCompare(b.nome, 'it'))
				.map(p => ({ value: p.value, text: `${p.nome} (${p.n})` }));
		},
		// utenti dello stesso profilo vicini: prima il nome del profilo, poi il nome dell'utente
		utenti() {
			const chiave = v => String(v || '').toLocaleLowerCase('it');
			const profilo = this.settings.filters.profile;
			const lista = (this.getUsers || []).filter(u => !profilo || String(u.profile) === profilo);
			return [...lista].sort((a, b) => chiave(a.profileName).localeCompare(chiave(b.profileName), 'it') || chiave(a.name).localeCompare(chiave(b.name), 'it'));
		},
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getToken: 'profile/getToken',
			getRole: 'profile/getRole',
			getUrl: 'settings/getUrl',
			getUsers: 'users/getUsers',
		}),
	},
	methods: {
		// stessi dati delle colonne Profilo/Email della tabella desktop
		campiCard(item) {
			return [
				{ label: 'Profilo', value: item.profileName || item.profile },
				{ label: 'Email', value: item.email },
			];
		},
		...mapMutations({
			setLogout: 'profile/setLogout',
			setPreload: 'settings/setPreload',
		}),
		...mapActions({
			fetchUsers: 'users/asyncFetchUsers',
			loginAs: 'profile/loginAs',
			createBadge: 'barcode/createBadge',
			toggleExpired: 'users/toggleExpired',
			toggleActive: 'users/toggleActive',
			resetTwoFactor: 'users/resetTwoFactor',
		}),
		notify(color, text) {
			this.$store.dispatch('settings/updateSnackbar', { color, text, snackbar: true, mode: 'multi-line', timeout: 5000 });
		},
		// la lista e' gia' tutta qui: pagina, ordinamento e filtri li applica la tabella
		listChanged() {},

		async initialize() {
			try {
				this.setPreload(true);
				await this.fetchUsers();
			} catch (err) {
				console.log(err);
			}
			this.setPreload(false);
			this.loaded = true;
		},
		// nuovo utente e modifica sono pagine: la lista resta nel suo URL e ci si torna uguale
		openNew() {
			this.$router.push('/users/new');
		},
		editItem(item) {
			this.$router.push(`/users/${item._id}`);
		},

		// il badge si apre in una finestra e si stampa: la finestra nasce nel click, se no il browser la blocca
		async createMyBadge(item) {
			const printPage = window.open('about:blank', '_blank');
			let badge = '';
			try {
				badge = await this.createBadge(item);
			} catch (e) {
				badge = '';
			}
			// in errore l'azione ritorna { error } invece dell'immagine
			if (!badge || typeof badge !== 'string') {
				if (printPage) printPage.close();
				this.notify('error', 'Badge non generato');
				return;
			}
			if (!printPage) {
				this.notify('error', 'Il browser ha bloccato la finestra del badge');
				return;
			}
			const img = printPage.document.createElement('img');
			img.src = badge;
			printPage.document.body.appendChild(img);
			setTimeout(() => printPage.print(), 1000);
		},

		deleteItem(item) {
			this.form = item;
			this.dialogconfirm = true;
		},
		confirmDelete() {
			this.dialogconfirm = false;
			if (!this.form || !this.form._id) return;
			this.setPreload(true);
			axios
				.post(`${this.getUrl}auth/delete`, { _id: this.form._id }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(() => {
					this.notify('success', 'Utente eliminato');
					return this.initialize();
				})
				.catch(err => {
					this.notify('error', err.message);
					if (err.response && err.response.status === 401) {
						this.setLogout();
						this.$router.push('/login');
					}
				})
				.finally(() => {
					this.setPreload(false);
				});
		},
		async executeLoginAs(user) {
			this.setPreload(true);
			const dataresponse = await this.loginAs({ email: user.email });
			if (dataresponse && dataresponse.status === 201) {
				window.location = '/';
				return;
			}
			this.setPreload(false);
			this.notify('error', (dataresponse && dataresponse.data && dataresponse.data.message) || 'Accesso non riuscito');
			if (dataresponse && dataresponse.response && dataresponse.response.status === 401) {
				this.setLogout();
				this.$router.push('/login');
			}
		},
		openTwoFactorReset(item) {
			this.pendingTwoFactorItem = item;
			this.dialogTwoFactorReset = true;
		},
		async confirmTwoFactorReset() {
			this.dialogTwoFactorReset = false;
			const ok = await this.resetTwoFactor({ _id: this.pendingTwoFactorItem._id });
			this.notify(ok ? 'success' : 'error', ok ? 'Verifica in due passaggi reimpostata' : 'Reimpostazione non riuscita');
			this.pendingTwoFactorItem = null;
		},
		openActiveConfirm(item, value) {
			this.pendingActiveItem = item;
			this.pendingActiveValue = value;
			this.dialogConfirmActive = true;
		},
		cancelActiveToggle() {
			this.dialogConfirmActive = false;
			this.pendingActiveItem = null;
			// il refetch riporta lo switch al valore reale: l'utente lo ha gia' mosso a video
			this.initialize();
		},
		async confirmActiveToggle() {
			this.dialogConfirmActive = false;
			try {
				await this.toggleActive({
					_id: this.pendingActiveItem._id,
					active: this.pendingActiveValue,
				});
			} catch (err) {
				this.notify('error', 'Errore aggiornamento stato utente');
				this.initialize();
			}
			this.pendingActiveItem = null;
		},
		openExpiredConfirm(item, value) {
			this.pendingExpiredItem = item;
			this.pendingExpiredValue = value;
			this.dialogConfirmExpired = true;
		},
		cancelExpiredToggle() {
			this.dialogConfirmExpired = false;
			this.pendingExpiredItem = null;
			// come per Attivo: lo switch a video torna al valore reale
			this.initialize();
		},
		async confirmExpiredToggle() {
			this.dialogConfirmExpired = false;
			try {
				await this.toggleExpired({
					profile: this.pendingExpiredItem.profile,
					active: this.pendingExpiredValue,
				});
			} catch (err) {
				this.notify('error', 'Errore aggiornamento stato expired');
				this.initialize();
			}
			this.pendingExpiredItem = null;
		},
	},
	beforeDestroy() {
		this.tour.stop();
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.user-cards,
.user-cards tr {
	display: block;
	width: 100%;
}
.user-cards tr,
.user-cards tr:hover {
	background: transparent !important;
}
.user-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.user-cards tr:first-child td {
	padding-top: 12px !important;
}
.user-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.user-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
</style>
